import React, { Fragment } from "react"
import styled from "react-emotion"
import Icon from "ui/components/Icon"

const NumberIcon = styled("span")`
    font-size: 15px;
    font-weight: 900;
    padding: 6px;
    font-face: Arial Black; Helvetica, Arial;
    letter-spacing: -2px;
`

export default [
    {
        name: "Blog",
        image: "https://cdn.filestackcontent.com/2viKKuchQ8Ghjp8Dz1kX",
        description: "A fully customisable blog template, ready to run your blog. Includes templates for static pages as well as blog posts.<br/><ul><li><b>Adapt the design</b> to exactly suit your needs with the page editor.</li><li><b>Manage the content</b> for your blog with the inbuilt admin app.</li><li><b>Organize your posts</b> into categories.</ul>",
        baseURL: "blog-template.stacker.app",
        tables: 2,
        blocks: 5,
        pages: 10
    }
]


// WEBPACK FOOTER //
// ./src/features/studio/utils/templates.js